/* tslint:disable */
/* eslint-disable */
/**
 * BS2
 * BoostSales 2
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CategoryEventProjectionName
 */
export interface CategoryEventProjectionName {
    /**
     * 
     * @type {string}
     * @memberof CategoryEventProjectionName
     */
    name: string;
}

/**
 * Check if a given object implements the CategoryEventProjectionName interface.
 */
export function instanceOfCategoryEventProjectionName(value: object): value is CategoryEventProjectionName {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CategoryEventProjectionNameFromJSON(json: any): CategoryEventProjectionName {
    return CategoryEventProjectionNameFromJSONTyped(json, false);
}

export function CategoryEventProjectionNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): CategoryEventProjectionName {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function CategoryEventProjectionNameToJSON(json: any): CategoryEventProjectionName {
    return CategoryEventProjectionNameToJSONTyped(json, false);
}

export function CategoryEventProjectionNameToJSONTyped(value?: CategoryEventProjectionName | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
    };
}

